import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SessionIdleService } from './core/services/session-idle.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterModule],
})
export class AppComponent {
  // The idle watcher is a providedIn-root service and is tree-shaken if
  // nothing injects it. Pulling it in here keeps it alive for the lifetime
  // of the app, so it can subscribe to the router and start when the user
  // reaches a page that would benefit from being signed out of.
  constructor(_idleWatcher: SessionIdleService) {}
}
